import { render, staticRenderFns } from "./recuperaDaSyncroModal.vue?vue&type=template&id=9e54910a&scoped=true&"
import script from "./recuperaDaSyncroModal.vue?vue&type=script&lang=js&"
export * from "./recuperaDaSyncroModal.vue?vue&type=script&lang=js&"
import style0 from "./recuperaDaSyncroModal.vue?vue&type=style&index=0&id=9e54910a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e54910a",
  null
  
)

export default component.exports